<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 3.09375C17.6949 3.09375 21.9062 7.30507 21.9062 12.5C21.9062 17.6949 17.6949 21.9062 12.5 21.9062C7.30507 21.9062 3.09375 17.6949 3.09375 12.5C3.09375 8.33619 5.7999 4.80639 9.54883 3.56836L8.58887 4.01172C5.38343 5.49104 3.15625 8.7348 3.15625 12.5C3.15625 17.6604 7.33959 21.8438 12.5 21.8438C17.3864 21.8438 21.3959 18.0933 21.8086 13.3135L21.8389 12.9658L21.1113 12.2383C21.0206 12.1475 20.9413 12.0461 20.875 11.9365L20.8135 11.8242L19.6885 9.57422L19.6143 9.44531C19.2366 8.87696 18.4462 8.74914 17.9082 9.16895L17.7969 9.26758C17.7754 9.28901 17.7464 9.30012 17.7168 9.2998L17.6875 9.2959L16.3613 8.91699C15.5071 8.67295 14.6229 9.13768 14.3262 9.9541L14.2744 10.1221C14.1133 10.7666 14.3483 11.4412 14.8643 11.8467L14.9707 11.9238L15.582 12.3311C15.7758 12.4602 15.8239 12.7162 15.707 12.9043L15.6465 12.9805L15.4375 13.1885C15.0771 13.5489 14.875 14.0382 14.875 14.5479V14.9756C14.875 15.1921 14.8308 15.4058 14.7461 15.6035L14.6475 15.7959L13.2783 18.0781C13.0167 18.5142 12.5456 18.7811 12.0371 18.7812C11.8443 18.7812 11.6875 18.6245 11.6875 18.4316V17.2119C11.6875 16.0259 11.0104 14.9523 9.95801 14.4355L9.74316 14.3389L9.06152 14.0664C8.40947 13.8056 8.01019 13.1524 8.06445 12.4629L8.08105 12.3252L8.08887 12.2812C8.11353 12.1333 8.15809 11.9893 8.22266 11.8545L8.29395 11.7227L8.38672 11.5674C8.71162 11.026 9.3231 10.7316 9.94238 10.8057L10.0664 10.8252L11.293 11.0703C12.2135 11.2544 13.1225 10.7472 13.459 9.88965L13.5176 9.71387L13.7354 8.9541C13.9894 8.06497 13.574 7.12072 12.7471 6.70703L12.0537 6.36035L11.5703 6.11914L11.0938 6.5957C10.7949 6.89457 10.3895 7.06248 9.9668 7.0625H9.77832C9.32052 7.0625 8.88131 7.24565 8.55859 7.56836C8.5076 7.61909 8.4366 7.6408 8.36914 7.63086L8.30371 7.61035C8.20343 7.56021 8.15886 7.44451 8.19336 7.34277L8.21387 7.2998L9.5459 5.0791L10.624 3.28125C11.2303 3.15855 11.8576 3.09375 12.5 3.09375Z"
				:stroke="color"
				stroke-width="1.5"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgAGDSubmitCEOnline',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
